import $ from 'jquery';

const defaultParams = {
  SortType      : '',
  sort          : '',
  ColorByName   : '',
  ColorGroup    : '',
  FaceType      : '',
  sd            : '',
  ed            : '',
  Size          : '',
  nvType        : '',
  period        : '',
  viewsite      : '',
  olpp          : '',
  page          : '',
  opage         : '',
  monochrome    : '',
  clipart       : '',
  lineart       : '',
  CclCommercial : '',
  CclDerivative : ''
};

export default $.extend(defaultParams, SF.urlParameter);


/** WEBPACK FOOTER **
 ** ./src/IIM/core/tab_params.js
 **/